import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import "../assets/css/footer/footer.css";
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className="container">
      <div className=" contents footer-menu">
        <div className="footer-menu-item">
          <div className="follow">
            Follow us:
            <a href="https://www.facebook.com/p/Cohesive-Staffing-Solutions-100057638200275/?_rdr" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon className="icon" icon={faFacebook} />
            </a>{" "}
            <a href="https://www.linkedin.com/company/cohesive-staffing/" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon className="icon" icon={faLinkedin} />
            </a>
          </div>
          <p className="footer-p">&copy; Copyright {currentYear}</p>
        </div>
        <div className="line"></div>
        <div className="apply-policy">
 <div className="apply-job">
          Are you looking for a job?{" "}
          <a
            href="https://secure7.saashr.com/ta/6212233.careers?CareersSearch=&ein_id=118982404&lang=en-US"
            className="apply"
            target="_blank"
            rel="noopener noreferrer"
          >
            Apply Now.
          </a>
       
        </div>
         <a href="privacy" className="policy">Privacy Policy</a>
        </div>
       
          
      </div>
    </div>
  );
};

export default Footer;
